export const UPDATE_ROUTE_NAME = 'UPDATE_ROUTE_NAME';
